// @flow

import type { Factor, Dictionary } from './types';

const spaceDescriptions: Dictionary = {
  'Small confined space': 0.86,
  'Large indoor space': 1.0,
  'Sheltered outdoor space': 1.3,
  'Unsheltered outdoor space': 1.5,
  'Fan Installed': 1.9
};

const ftFactors: Factor = [
  [-20, 1.64],
  [0, 1.5],
  [20, 1.36],
  [40, 1.22],
  [60, 1.07],
  [68, 1],
  [80, 0.92],
  [100, 0.77],
  [120, 0.63],
  [120.1, 0.63]
];

const fdFactors: Factor = [
  [19.9, 1.8],
  [20, 1.8],
  [40, 1.35],
  [70, 1.15],
  [80, 1.05],
  [100, 1]
];

const fhFactors: Factor = [
  [0, 1],
  [2461, 0.95],
  [4921, 0.9],
  [7382, 0.85],
  [9843, 0.81],
  [12303, 0.77],
  [14764, 0.72],
  [17224, 0.68],
  [17224.1, 0.68]
];

const xbkBushings: Dictionary = {
  'Gearbox Maximum': 0,
  '1.3125" (1 5/16")': 1.3125,
  '1.375" (1 3/8")': 1.375,
  '1.4375" (1 7/16")': 1.4375,
  '1.5" (1 1/2")': 1.5,
  '1.625" (1 5/8")': 1.625,
  '1.6875" (1 11/16")': 1.6875,
  '1.75" (1 3/4")': 1.75,
  '1.875" (1 7/8")': 1.875,
  '1.9375" (1 15/16")': 1.9375,
  '2" (2")': 2,
  '2.1875" (2 3/16")': 2.1875,
  '2.4375" (2 7/16")': 2.4375,
  '2.9375" (2 15/16")': 2.9375,
  '3.4375" (3 7/16")': 3.4375,
  '3.9375" (3 15/16")': 3.9375,
  '4.4375" (4 7/16")': 4.4375,
  '4.9375" (4 15/16")': 4.9375
};

const bushingFactors: Array<[number, string]> = [
  [1.3125, '1 5/16"'],
  [1.375, '1 3/8"'],
  [1.4375, '1 7/16"'],
  [1.5, '1 1/2"'],
  [1.625, '1 5/8"'],
  [1.6875, '1 11/16"'],
  [1.75, '1 3/4"'],
  [1.875, '1 7/8"'],
  [1.9375, '1 15/16"'],
  [2, '2"'],
  [2.1875, '2 3/16"'],
  [2.4375, '2 7/16"'],
  [2.9375, '2 15/16"'],
  [3.4375, '3 7/16"'],
  [3.9375, '3 15/16"'],
  [4.4375, '4 7/16"'],
  [4.9375, '4 15/16"']
];

const xbkShaftWarnings: { [string]: Array<number> } = {
  'XBK2': [1.625, 1.6875],
  'XBK3': [1.875, 1.9375],
  'XBK4': [2.25, 2.4375],
  'XBK5': [2.5, 2.6875],
  'XBK6': [3, 3.4375],
  'XBK7': [3.1875, 3.4375],
  'XBK8': [3.4375, 3.9375],
  'XBK9': [3.9375, 4.4375]
};

export {
  spaceDescriptions,
  ftFactors,
  fdFactors,
  fhFactors,
  xbkBushings,
  bushingFactors,
  xbkShaftWarnings
};



// WEBPACK FOOTER //
// ./src/utils/vortex/thermal-factors.js